<template>
    <div class="row">
        <div class="col-12" v-if="title">
            <TitleComponent class="tw:pr-5" :title="'ZONA SELECCIONADA: ' + zona.name"/>
        </div>
        <div class="col-12">
            <h1>{{ zona.sector }}</h1>
        </div>
        <div class="col-12">
            <p>Haz click en el siguiente selector para cambiar de zona</p>
            <div class="form-group tw:pr-5" v-if="zonas">
                <multiselect
                    v-model="zona_seleccionada"
                    placeholder="Seleccionar zona"
                    label="name"
                    style="width: 95%"
                    :options="select_zonas"
                    :disabled="bloquearPasoDos"
                    @select="cambiarZona"
                />
            </div>
        </div>
        <div class="col-12">
            <div class="col-12 text-center" v-if="zonas">
                <SvgComponent 
                    :zonas="zonas" 
                    :place="place" 
                    :sesion_id="sesion_id"
                    @clickZona="irAZona"
                />                
            </div>
        </div>
    </div>
</template>

<script>
    import TitleComponent from '@/components/backend/stepper/components/TitleComponent';     
    import SvgComponent from '@/components/svg/SvgComponent';

    export default {
        props: ['zona', 'zonas', 'dia_abonado', 'place', 'sesion_id', 'bloquearPasoDos'],
        data() {
            return {
                loading: true,
                title: true,
                zona_seleccionada: ''
            }
        },
        created() {
            this.zona_seleccionada = this.zona;
        },
        computed: {
            select_zonas() {
                var select = [];
                for (var i = 0; i < this.zonas.length; i++) {
                    if(this.zonas[i].esta_disponible) {
                        select.push(this.zonas[i]);
                    }
                }

                return select;
            },
        },
        watch: {
            zona() {
                this.zona_seleccionada = this.zona
            },
            loading() {
                this.title = false;
                this.title = true;
            }
        },
        methods: {
            cambiarZona(zona) {
                this.$emit('cambiarZona', zona)
                this.zona_seleccionada = zona;
            }, 
            irAZona(zona) {
                this.$emit('cambiarZona', zona);
            }
        },
        components: {
            TitleComponent, SvgComponent
        }
    }
</script>
